import { Component } from '@angular/core';

@Component({
  selector: 'app-step-complete',
  templateUrl: './step-complete.component.html',
  styleUrl: './step-complete.component.css'
})
export class StepCompleteComponent {

}
